import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer, useRelationshipDiscoverer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'cars/service';
const model = 'cars/service';
const wizardName = 'Edit PIN';
const wizardObject = 'Service';
const wizardAction = 'editPIN';

const EditPin = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities } = useContext(AppContext);

    // DATA PROVIDER
    const {
        item,
        doAction,
        errorMessage,
        errors,
        saving,
        success
    } = useDataProvider(dataProviderName, false);


    const detailConfig = {
        "tabs": [
            {
                "name": "PIN",
                "fieldsets": [
                    {
                        "name": "PIN",
                        "fields": {
                            "pin": {
                                "type": "text",
                                "required": true,
                                "className": "col-12",
                                "icon": "faInputNumeric"
                            }
                        }
                    }
                ]
            }
        ],
        "validation": []
    }


    useEffect(() => {
        if (success) {
            //close();
            window.location.reload(true);
        }
    }, [success]);

    const handleSave = async (data) => {
        doAction && doAction({ action: wizardAction, model: model ? model : dataProviderName, data: data });
    }

    return <>
        <DetailComponent
            disableDetailConfigOverride={true}
            values={{
                "id": params.item.id,
                "pin": params.item.pin,
                "type": params.item.type,
                "identifier": params.item.identifier
            }}
            modelName={model.split('/')[1]}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Edit the PIN of the selected service')}
                />
            }
            {...params}
        />
    </>
}

export default EditPin;


